import { StrictMode } from 'react'
import { createRoot, hydrateRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import App from './App'
import { splitLocale } from '@/lib/seo'
import '@/styles/globals.css'
import '@/styles/Scrollbar.css'

const container = document.getElementById('root')!
const app = (
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>
)

// Production HTML is prerendered per route and language (vite.config.ts);
// hydrate it. The dev server serves the empty shell, and 404.html is the
// German prerender also served under /en/…, so render from scratch there.
const prerendered = document.documentElement.lang === splitLocale(window.location.pathname).locale
if (container.firstElementChild && prerendered) hydrateRoot(container, app)
else {
  container.replaceChildren()
  createRoot(container).render(app)
}
